<template>
    <f7-page name="hydro-vystrahy-detail" @page:init="onPageInit">
        <f7-navbar>
            <f7-nav-left>
                <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
            </f7-nav-left>
            <f7-nav-title sliding>{{ pageTitle }}</f7-nav-title>
            <f7-nav-right>
                <f7-link icon-ios="f7:arrow_2_circlepath" icon-aurora="f7:arrow_2_circlepath" icon-md="material:autorenew" @click="pageReload($event,false) " href="#" ></f7-link>
                <f7-link icon-ios="f7:arrow_left" icon-aurora="f7:arrow_left" icon-md="material:arrow_back" @click="$f7router.back()" href="#" ></f7-link>
            </f7-nav-right>
        </f7-navbar>

        <template v-if="notEmptyObject(selectedData)">

            <f7-card>
                <f7-card-header :class="'vystraha-' + selectedData.stupen">{{ selectedData.stupen }}. stupeň</f7-card-header>
                <f7-card-content>
                    <div class="display-inline-block">
                        <img v-for="druh in selectedData.druhy" :src="'static/shmu/img/hydrovystrahy/'+druh.druh_id+'.svg'" width="64">
                    </div><br>
                    <strong>Druh výstrahy:</strong>
                    <ul class="no-margin mb-1">
                        <li v-for="druh in selectedData.druhy">{{ druh.druh_nazov }}</li>
                    </ul>
                    <strong>Platnosť od:</strong> od {{ selectedData.dt_platnost_od*1000 | moment('DD.MM.YYYY HH:mm') }}<br>
                    <strong>Platnosť do:</strong> do <template v-if="!selectedData.dt_platnost_do">odvolania</template>
                    <template v-else>{{ selectedData.dt_platnost_do*1000 | moment('DD.MM.YYYY HH:mm') }}</template>
                    <div class="mt-1 font-weight-bold">Výstraha:</div>
                    <p class="no-margin">{{ selectedData.text_vystrahy }}</p>

                </f7-card-content>
                <f7-card-footer>
                    Aktualizované: {{ selectedData.dt_add*1000 | moment('DD.MM.YYYY HH:mm') }}
                </f7-card-footer>
            </f7-card>

        </template>

    </f7-page>
</template>
<script>
    import Axios from "axios";
    import SHMUconf from "../js/SHMUconf";


    export default {
        data: function () {
            return {
                pageTitle: 'Hydro výstrahy',
                selectedData: {},
                selectedRegion: null,
            };
        },
        mounted() {
            const self = this;
            // otvorime hlavne menu
            this.$f7.accordion.close('.shmu-i-vodne-zdroje');
            this.$f7.accordion.open('.shmu-i-vodne-zdroje');
        },
        destroy() {
            clearInterval(this.tCheckInterval);
            this.selectedData = {};
            this.selectedRegion = null;
        },
        methods: {
            onPageInit() {
                this.selectedRegion = this.$f7route.params.region;
                this.pageReload(null, true);
            },
            pageReload(event, isInit) {
                const self = this;

                if (this.selectedRegion && (isInit || (this.$moment().unix() - this.lastUpdated) > 60)) {
                    this.loadHydroWarningData(this.selectedRegion);
                } else {
                    if (!this.selectedRegion) {
                        self.$f7.dialog.alert('Identifikátor oblasti pre hydrologické výstrahy nebol správne určený!', 'Nastala chyba');
                    }
                }
            },
            loadHydroWarningData(region) {
                const self = this;

                self.$f7.dialog.preloader('Načítavam...');
                Axios.get(SHMUconf.API_BASE_URL + 'hydro/getwarnings?region=' + region, {
                    crossDomain: true,
                    cache: false,
                })
                    .then((response) => {
                        if (!response.data.error) {
                            self.selectedData = response.data;
                            self.pageTitle = self.selectedData.okres.nazov_okres + ' - Hydro výstrahy';
                            self.lastUpdated = self.$moment().unix();
                            // clearInterval(this.tCheckInterval);
                            // this.tCheckInterval = setInterval(this.checkLastUpdated, 5 * 60 * 1000); // overujem kazdych 5 min
                        } else {
                            self.$f7.dialog.alert('Nepodarilo sa načítať hydrologické výstrahy', 'Nastala chyba');
                        }
                        self.$f7.dialog.close();
                    }).catch((error) => {
                    self.$f7.dialog.close();
                    self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
                });

            },
            checkLastUpdated() {
                if ((this.$moment().unix() - this.lastUpdated) >= 5*60) { // ak posledne stiahnutie bolo pred vic ako 5 min, tak refresh
                    this.pageReload(null, false);
                }
            },


        }

    };
</script>

